/* Bascule Achat unique / Abonnement du configurateur.

   Les prix d'abonnement viennent des attributs data-sub, remplis par Liquid
   depuis selling_plan_allocations : c'est Shopify qui calcule la remise, pas
   ce script. Un pourcentage code ici pourrait diverger de ce que le client
   paie reellement au paiement.

   La bascule ne s'affiche que pour les formats dont AU MOINS un palier a un
   prix d'abonnement valide. Sur un format dont les paliers sont remises par
   une app de bundles, l'abonnement revient plus cher : Liquid n'emet alors
   aucun data-sub, et la bascule disparait pour ce format. */
(function () {
  'use strict';
  document.querySelectorAll('[data-buy-configurator]').forEach(function (root) {
    var modeBox = root.querySelector('.mode');
    if (!modeBox) return;

    var planInput = root.querySelector('[data-buy-plan]');
    var cta = root.querySelector('.buy-cta');
    var base = cta ? cta.dataset.baseLabel : '';
    var mode = 'once';

    function visibleGroup() { return root.querySelector('.tiers:not([hidden])'); }
    function groupHasSub(g) { return g && g.querySelector('input[data-sub]') !== null; }

    function syncToggleVisibility() {
      var ok = groupHasSub(visibleGroup());
      modeBox.hidden = !ok;
      if (!ok && mode === 'sub') {
        mode = 'once';
        modeBox.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x.dataset.mode === 'once'));
        });
      }
    }

    function paint() {
      syncToggleVisibility();

      root.querySelectorAll('.tiers input').forEach(function (r) {
        var label = r.closest('.tier');
        var priceEl = label.querySelector('[data-tier-price]');
        var unitEl = label.querySelector('[data-tier-unit]');
        var suffix = unitEl ? (unitEl.textContent.match(/\/\D+$/) || [''])[0] : '';
        var useSub = mode === 'sub' && r.dataset.sub;
        if (priceEl) priceEl.textContent = useSub ? r.dataset.sub : r.dataset.price;
        if (unitEl) unitEl.textContent = (useSub ? r.dataset.subUnit : r.dataset.unit) + suffix;
      });

      var r = root.querySelector('.tiers:not([hidden]) input:checked');
      if (!r) return;
      var useSub = mode === 'sub' && r.dataset.sub;
      if (planInput) {
        var btn = modeBox.querySelector('[data-mode="sub"]');
        planInput.value = useSub ? (btn ? btn.dataset.plan : '') : '';
        planInput.disabled = !useSub;
      }
      if (cta) cta.textContent = base + ' — ' + (useSub ? r.dataset.sub : r.dataset.price);
    }

    modeBox.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.dataset.mode;
        modeBox.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        paint();
      });
    });

    /* Le choix de palier et de format est gere par theme.js ; on repeint
       ensuite pour que le mode et la visibilite restent coherents. */
    root.addEventListener('click', function (e) {
      if (e.target.closest('.tier') || e.target.closest('.fmt-opt')) setTimeout(paint, 0);
    });

    paint();
  });
})();
